import type { QueueQuery } from '../api/tickets';

const STORAGE_KEY = 'sd.queue.views';

export interface SavedView {
  id: string;
  name: string;
  query: QueueQuery;
}

// Default views — всегда доступны, не сохраняются.
export const BUILTIN_VIEWS: SavedView[] = [
  { id: 'my',         name: 'Мои',           query: { assignee: 'me', sort_by: 'priority', sort_dir: 'asc' } },
  { id: 'unassigned', name: 'Без агента',    query: { assignee: 'unassigned', sort_by: 'created_at', sort_dir: 'asc' } },
  { id: 'urgent',     name: 'Срочные (P1/P2)', query: { sort_by: 'priority', sort_dir: 'asc' } },
  { id: 'open',       name: 'Активные',      query: { status: 'open' } },
  { id: 'all',        name: 'Все',           query: { sort_by: 'created_at', sort_dir: 'desc' } },
];

export function loadSavedViews(): SavedView[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function saveView(v: SavedView) {
  const all = loadSavedViews().filter(x => x.id !== v.id);
  all.push(v);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
}

export function deleteView(id: string) {
  const all = loadSavedViews().filter(x => x.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
}
